import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import desktopBackground from "../../assets/images/desktopBackground.png";
import logo from "../../assets/images/logo-default.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import fingerprint from "../../assets/images/icon_login/fingerprint.svg";
import bsi from "../../assets/images/bsi.png";
import * as API from "../../core/service/api.js";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeOff from "../../assets/images/icon_login/eye-off.svg";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createPassword } from "../../core/service/api_profile";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import CustomApp from "../../core/models/customApp";
import { removeToken } from "../../core/feature/token/tokenSlice";
import { removeUser } from "../../core/feature/user/userSlice";

const ConfirmationDataMobile = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const location: any = useLocation();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [credential, setCredential] = useState<any>({});
  const [resCredential, setResCredential] = useState<any>({});
  const [resLogin, setResLogin] = useState<any>({});
  const [typePassword, setTypePassword] = useState("password");
  const [typePassword2, setTypePassword2] = useState("password");
  const [disableNextButton, setDisableNextButton] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );

  const next = async () => {
    const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if (email && !phone) {
      if (!regexEmail.test(email)) {
        return toast.warning(t("LOGIN.warningEmail"));
      }
    }

    if (phone && !email) {
      if (phone.length < 10) {
        return toast.warning(t("LOGIN.warningWA"));
      }
    }

    // if (!email) {
    //   return toast.warning(t("LOGIN.warningEmail"));
    // }

    // if (!phone) {
    //   return toast.warning(t("LOGIN.warningWA"));
    // }

    const query = {
      email: email,
      password: credential?.password,
      phone: phone,
    };

    dispatch(setLoading(true));

    createPassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        localStorage.setItem("auto_login", "1");

        navigate("intro", {
          replace: true,
          state: {
            credential: credential,
            email: email,
            phone: phone,
          },
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  const checkEmail = async (value: any) => {
    setEmail(value);
    setDisableNextButton(!value && !phone);
  };

  const checkWA = async (value: any) => {
    setPhone(value);
    setDisableNextButton(!value && !email);
  };
  useEffect(() => {
    setCredential(location.state.credential);
    if (!location.state.email && !location.state.phone) {
      setDisableNextButton(true);
    } else {
      setDisableNextButton(false);
    }
    setEmail(location.state.email);
    setPhone(location.state.phone);
  }, []);
  return (
    <>
      <div className="min-h-screen font-montserrat h-full p-10 bg-psp-primary">
        <div className="mt-24">
          <img src={logo} className="w-52 mx-auto" />
        </div>
        <div className="mt-10">
          <h1 className="text-xl font-bold text-[#0054E6]">
            {t("CONFIRMATIONDATA.title")}
          </h1>
          <p className="text-sm font-medium text-[#B9B9B9] mb-9">
            {t("CONFIRMATIONDATA.subtitle")}
          </p>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-2">
              <div className="flex items-center space-x-1">
                <h1 className="font-montserrat  text-sm text-[#B9B9B9] leading-5 font-medium pl-1 mb-0">
                  Email
                </h1>
                <p className="text-sm font-medium text-[#f82626]">*</p>
              </div>
              <input
                type="text"
                value={email}
                onChange={(e) => checkEmail(e.target.value)}
                className="px-3 grow text-sm rounded-lg h-10 border-1 border-psp-gray border-solid disabled:text-psp-nav"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center space-x-1">
                <h1 className="font-montserrat  text-sm text-[#B9B9B9] leading-5 font-medium pl-1 mb-0">
                  Nomor Whatsapp
                </h1>
                <p className="text-sm font-medium text-[#f82626]">*</p>
              </div>
              <input
                type="phone"
                value={phone}
                onChange={(e) => checkWA(e.target.value)}
                className="px-3 grow text-sm rounded-lg h-10 border-1 border-psp-gray border-solid disabled:text-psp-nav"
              />
            </div>
          </div>
          <button
            onClick={() => next()}
            // disabled={phone == "" || email == ""}
            disabled={disableNextButton}
            className={
              disableNextButton
                ? `px-4 mt-4 bg-[#a0a0a0] text-[#EAEAEA] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-[#888]`
                : `px-4 mt-4 bg-[#0054E6] text-[#EAEAEA] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active`
            }
          >
            {t("OTHER.next")}
          </button>
          <button
            onClick={() => (
              navigate("/login", { replace: true }),
              dispatch(removeCompany),
              dispatch(removeToken),
              dispatch(removeUser)
            )}
            className="px-4 mt-2 bg-transparent border-[0.5px] border-solid border-[#0054E6] text-[#0054E6] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
          >
            {t("OTHER.back")}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmationDataMobile;
